const FromArrEditor = [{
		key: 'ImplantType',
		modelvalue: undefined,
		title: "今/明植入：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [{
			key: '0',
			value: '今日'
		}, {
			key: '1',
			value: '明日'
		}]
	}, {
		key: 'SurgeryTime',
		modelvalue: undefined,
		title: "时间：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: Array.from({
			length: 24
		}, (_, i) => ({
			key: i,
			value: `${i}点`
		})),
	},
	{
		key: 'Hospital',
		title: "医院：",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 75,
		marginTop: 15,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'Hospital',
	}, {
		key: 'TechnicalOffices',
		title: "科室：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		key: 'Doctor',
		title: "术者：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 200,
		height: 32,
		disabled: false,
		marginLeft: 75,
		marginTop: 8,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
];
export default FromArrEditor;